module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("enUKp"))).then(() => parcelRequire('dJXJK'));